import { render, staticRenderFns } from "./DomainsListContent.vue?vue&type=template&id=878c6fe8"
import script from "./DomainsListContent.vue?vue&type=script&lang=ts"
export * from "./DomainsListContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports